export const FETCH_MESSAGES_SUCCESS = 'FETCH_MESSAGES_SUCCESS';
export const FETCH_MESSAGES_FAILURE = 'FETCH_MESSAGES_FAILURE';
export const CREATE_MESSAGE_SUCCESS = 'CREATE_MESSAGE_SUCCESS';
export const CREATE_MESSAGE_FAILURE = 'CREATE_MESSAGE_FAILURE';
export const UPDATE_MESSAGE_SUCCESS = 'UPDATE_MESSAGE_SUCCESS';
export const UPDATE_MESSAGE_FAILURE = 'UPDATE_MESSAGE_FAILURE';
export const THUMBS_UP_SUCCESS = 'THUMBS_UP_SUCCESS';
export const THUMBS_UP_FAILURE = 'THUMBS_UP_FAILURE';
export const THUMBS_DOWN_SUCCESS = 'THUMBS_DOWN_SUCCESS';
export const THUMBS_DOWN_FAILURE = 'THUMBS_DOWN_FAILURE';
export const SUBMIT_FEEDBACK_SUCCESS = 'SUBMIT_FEEDBACK_SUCCESS';
export const SUBMIT_FEEDBACK_FAILURE = 'SUBMIT_FEEDBACK_FAILURE';
export const COPY_MESSAGE_SUCCESS = 'COPY_MESSAGE_SUCCESS';
export const COPY_MESSAGE_FAILURE = 'COPY_MESSAGE_FAILURE';
export const REGENERATE_BUTTON_SUCCESS = 'REGENERATE_BUTTON_SUCCESS';
export const REGENERATE_BUTTON_FAILURE = 'REGENERATE_BUTTON_FAILURE';
export const GENERATE_MESSAGE_SUCCESS = 'GENERATE_MESSAGE_SUCCESS';
export const GENERATE_MESSAGE_FAILURE = 'GENERATE_MESSAGE_FAILURE';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const CLEAR_MESSAGES_SUCCESS = 'CLEAR_MESSAGES_SUCCESS';
export const CLEAR_MESSAGE_ERROR = 'CLEAR_MESSAGE_ERROR';
